import { render, staticRenderFns } from "./idioma-el.vue?vue&type=template&id=3b5fcee0"
import script from "./idioma-el.vue?vue&type=script&lang=js"
export * from "./idioma-el.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports